import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { prettyDate } from '../../tools/date';
import postTranslations from '../../controllers/postTranslation';
import { addDynamic, deleteDynamic, getDynamics } from '../../dbDynamicList';

export default class ReportsRow extends Component {
  static defaultProps = {};

  state = {
    loadingDoc: false,
    dynamicTranslatedText: '',
    dynamicTranslatedTitle: '',
    dynamicTranslatedCat: [],
  };

  async componentDidMount() {
    const { report, pageType } = this.props;
    const lang = localStorage.getItem('language').split('-')[0];
    const dynamicToTranslate = {
      title: report.title.rendered,
      text: report.excerpt.rendered,
      categories: report?.page_category?.map(item => item.name),
    };
    if (lang !== 'it') {
      const dataReport = await getDynamics(pageType);
      if (dataReport) {
        const currentReport = dataReport.find(rp => rp.idReport === report.id);
        if (currentReport) {
          this.setState({
            dynamicTranslatedTitle: currentReport?.translation?.title,
          });
          this.setState({
            dynamicTranslatedText: currentReport?.translation?.text,
          });
          this.setState({
            dynamicTranslatedCat:
              currentReport?.translation?.categories.split(','),
          });
        }
      }
      const checkData = dataReport.find(rp => rp.idReport === report.id);
      const checkDataByDate = checkData?.dateReport !== report.date;
      if (!checkData || checkDataByDate) {
        this.setState({ loadingDoc: true });
        postTranslations(
          {
            title: dynamicToTranslate.title,
            text: dynamicToTranslate.text,
            categories: `${dynamicToTranslate.categories}`,
          },
          lang
        ).then(async res => {
          if (
            !res ||
            (res && res?.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              dynamicTranslatedTitle: dynamicToTranslate.title,
            });
            this.setState({
              dynamicTranslatedText: dynamicToTranslate.text,
            });
            this.setState({
              dynamicTranslatedCat: dynamicToTranslate.categories,
            });
            this.setState({ loadingDoc: false });
          } else {
            this.setState({
              dynamicTranslatedTitle: res?.translation?.title,
            });
            this.setState({
              dynamicTranslatedText: res?.translation?.text,
            });
            this.setState({
              dynamicTranslatedCat: res?.translation?.categories.split(','),
            });
            if (dataReport) {
              const checkData = dataReport.find(
                rp => rp.idReport === report.id
              );
              const checkDataByDate = dataReport.find(
                rp => rp.idReport === report.id && rp.dateReport !== report.date
              );
              if (!checkData) {
                addDynamic(
                  {
                    ...res,
                    idReport: report.id,
                    dateReport: report.date,
                  },
                  pageType
                );
              } else if (checkDataByDate) {
                deleteDynamic(checkDataByDate.id, pageType);
                addDynamic(
                  {
                    ...res,
                    idReport: report.id,
                    dateReport: report.date,
                  },
                  pageType
                );
              }
            }
            this.setState({ loadingDoc: false });
          }
        });
      }
    }
  }

  render() {
    const { odd, report, pageType } = this.props;
    const { date, id, page_category } = report;
    const {
      dynamicTranslatedCat,
      dynamicTranslatedText,
      dynamicTranslatedTitle,
      loadingDoc,
    } = this.state;
    const lang = localStorage.getItem('language').split('-')[0];
    return (
      <>
        <li className={`media ${odd ? 'my-4' : ''}`}>
          <div className="media-body">
            <div className="mb-1 report-list-title">
              <Link to={`/page/${pageType}/${id}`}>
                <h3
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === 'it' || loadingDoc
                        ? report.title.rendered
                        : dynamicTranslatedTitle,
                  }}
                />
              </Link>
            </div>
            <div className="report-tags">
              {(page_category || []).map((tag, i) => (
                <span key={tag.id} className="badge report-tag">
                  {lang === 'it' || loadingDoc
                    ? tag.name
                    : dynamicTranslatedCat?.[i]}
                </span>
              ))}
            </div>
            <div
              className="report-excerpt"
              dangerouslySetInnerHTML={{
                __html:
                  lang === 'it' || loadingDoc
                    ? report.excerpt.rendered
                    : dynamicTranslatedText,
              }}
            />
            <span className="date-label small">
              {prettyDate(new Date(date))}
            </span>
          </div>
        </li>
        {loadingDoc && <p>translating...</p>}
      </>
    );
  }
}
